import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const MIN_GAP_MS = 60 * 1000;

// The signed-in user is cached in localStorage at login, so task switches the
// admin flips afterwards would only show up after the next login. On page
// changes (at most once a minute) re-read the account and merge the fresh
// switches in. Only `permissions`/`tasks` are merged: the rest of the stored
// user keeps the shape the login screens wrote, which pages rely on.
// The server enforces switches on its own regardless; this only keeps the
// menus and buttons in step.
const UserTasksRefresher = () => {
  const location = useLocation();
  const lastRun = useRef(0);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token || Date.now() - lastRun.current < MIN_GAP_MS) return;
    lastRun.current = Date.now();
    let cancelled = false;
    axios.get('/api/auth/me', { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => {
        if (cancelled || !data?.user) return;
        let stored;
        try { stored = JSON.parse(localStorage.getItem('user') || 'null'); } catch { stored = null; }
        if (!stored || String(stored.id || stored._id) !== String(data.user.id)) return;
        const next = { ...stored, permissions: data.user.permissions || [], tasks: data.user.tasks || [] };
        if (JSON.stringify(next) !== JSON.stringify(stored)) {
          localStorage.setItem('user', JSON.stringify(next));
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [location.pathname]);

  return null;
};

export default UserTasksRefresher;
